import { AnimationOnScroll } from 'react-animation-on-scroll';
import Image from 'next/image';
import KetoContainer from './keto-container';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';
import styles from './keto-intro.module.css';

export default function KetoIntro() {
  return (
    <section className={styles.intro}>
      <KetoContainer>
        <AnimationOnScroll
          animateOnce
          duration={2}
          animateIn="animate__fadeIn"
          className={styles.intro_inner}
        >
          <div className={styles.intro_start}>
            <KetoTypography
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
              className={styles.intro_title}
            >
              KetoKitchen
            </KetoTypography>
            <KetoTypography
              variant={KetoTypographyVariant.BODY_2}
              tag="p"
              className={styles.intro_text}
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </KetoTypography>
            <span className={styles.soon}>Coming Soon</span>
            <a className={styles.intro_apple} href="#">
              <img src="/keto/icons/apple-store.svg" alt="heart" />
            </a>
          </div>
          <div className={styles.intro_end}>
            <Image
              alt="keto kitchen icons"
              width={771}
              height={565}
              src="/keto/icons/Group.png"
            />
            <div className={styles.intro_wrapper}>
              <Image
                alt="keto kitchen app preview"
                width={378}
                height={565}
                className={styles.intro_image}
                src="/keto/intro/intro-img.png"
              />
            </div>
          </div>
          <img
            className={styles.intro_heart}
            src="/keto/icons/heart-intro.svg"
            alt="heart icon"
          />
        </AnimationOnScroll>
      </KetoContainer>
    </section>
  );
}
